module.exports = __webpack_public_path__ + "img/body_2.e6d74b07.png";